export default {
  next_products_url: "products?page=1",
  next_available_products_url: "products/available?page=1",
  next_products_url_search: "",
  products: [],
  new_products: [],
  available_products: [],
  success: "",
  errors: [],
  error_msg: "",
};
